// extracted by mini-css-extract-plugin
export default {"form":"ResetAccountPage_form__yhGDy","heading":"ResetAccountPage_heading__PEv-m","head":"ResetAccountPage_head__ARXKr"};